import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { competencies } from '../data/competencies';
const section = sections[5];
export function ValueProposition() {
  return <div data-id="element-301" data-mp="18jafif6l833r">
      <PageHeader section={section} intro="Why a board appoints Janice Munday, and the six competencies she is appointed for." data-id="element-302" data-mp="18ir5rlr3cl0t" />

      <section className="mt-12 grid gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-303" data-mp="fttn3hiywm7j">
        <div data-id="element-304" data-mp="ks4xbtd6cyqa">
          <h2 className="font-serif text-2xl leading-tight text-navy" data-id="element-305" data-mp="krv6k3kb2njj">
            The proposition
          </h2>
          <div className="mt-6 space-y-5 text-[15px] leading-relaxed text-slateink" data-id="element-306" data-mp="pqg7k57dtb91">
            <p data-id="element-307" data-mp="ur3zct3fpw4b">
              Industrial businesses fail their owners in predictable ways: they
              under-invest in capability, they mistake political goodwill for
              strategy, and they lose their nerve at the moment of transition.
              Janice is appointed to boards precisely to close those gaps.
            </p>
            <p data-id="element-308" data-mp="1l9q6ax1xuds7">
              She offers three things at once, which rarely arrive in the same
              person — the government insider’s command of how national
              industrial policy and funding actually work; the chair’s
              discipline in running a board that decides rather than deliberates;
              and the operator’s patience with the long timescales of
              manufacturing, materials and defence.
            </p>
            <p data-id="element-309" data-mp="xkoseuac6afj">
              The result is a director who can hold a board steady through an
              ownership change, a chief executive succession or a
              decarbonisation programme that will outlast the current
              management team — while keeping the executive supported enough to
              deliver it.
            </p>
          </div>

          <figure className="mt-10 border-l-2 border-gold bg-white p-7 shadow-panel" data-id="element-310" data-mp="em2rpgiqelc5">
            <blockquote className="font-serif text-lg italic leading-relaxed text-navy" data-id="element-311" data-mp="eo5oqkiaxeqd">
              “Good governance in industry is not administration. It is the
              discipline that allows a business to make decisions it will still
              be proud of in ten years.”
            </blockquote>
            <figcaption className="mt-4 text-[11px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-312" data-mp="3w4ruek6cmuzs">
              Janice Munday
            </figcaption>
          </figure>
        </div>

        <div data-id="element-313" data-mp="so1jbqvwtrr8">
          <h2 className="text-[11px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-314" data-mp="snrq7ufkj4hb">
            Board competencies
          </h2>
          <ul className="mt-6 grid grid-cols-1 gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2" data-id="element-315" data-mp="dylu4fc11udn">
            {competencies.map(item => {
            const Icon = item.icon;
            return <li key={item.title} className="flex h-full flex-col bg-white p-7" data-id="element-316" data-mp="16lpsw2kj1cgz">
                  <span className="flex h-11 w-11 items-center justify-center border border-gold/40 bg-gold/10 text-gold-dark" data-id="element-317" data-mp="1bg3voq1iqlvo">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-318" data-mp="2w2lgk6sb48cx" />
                  </span>
                  <h3 className="mt-5 font-serif text-lg leading-snug text-navy" data-id="element-319" data-mp="2r40nqsfdwqyi">
                    {item.title}
                  </h3>
                  <p className="mt-auto pt-3 text-[13px] leading-relaxed text-slateink-light" data-id="element-320" data-mp="30vehskokgyk9">
                    {item.detail}
                  </p>
                </li>;
          })}
          </ul>
        </div>
      </section>
    </div>;
}